import { render, staticRenderFns } from "./MultiTable.vue?vue&type=template&id=44d1b45a&scoped=true"
import script from "./MultiTable.vue?vue&type=script&lang=js"
export * from "./MultiTable.vue?vue&type=script&lang=js"
import style0 from "./MultiTable.vue?vue&type=style&index=0&id=44d1b45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d1b45a",
  null
  
)

export default component.exports